import { tr } from '@/i18n/copy';

export default function BillingInterval({ value, onChange, disabled = false }) {
  return <fieldset className="space-y-2" disabled={disabled}>
    <legend className="mb-2 text-sm font-semibold">{tr('Come preferisci pagare?')}</legend>
    <div className="flex flex-wrap gap-2">
      {[['month', tr('Mensile')], ['year', tr('Annuale · 1 mese gratis')]].map(([interval, label]) =>
        <button key={interval} type="button" aria-pressed={value === interval}
          onClick={() => onChange(interval)}
          className={`rounded-xl border px-4 py-3 text-sm font-semibold transition-colors disabled:opacity-50 ${value === interval ? 'border-red-600 bg-red-600 text-white' : 'border-zinc-500 bg-zinc-900 text-zinc-100 hover:bg-zinc-800'}`}>
          {label}
        </button>)}
    </div>
    <p className="max-w-2xl text-sm text-muted-foreground">{tr('14 giorni di prova gratuita, senza addebiti automatici. Per continuare, scegli e attiva il mensile o l’annuale. L’annuale copre 12 mesi con un unico pagamento pari a 11 mensilità a tariffa costante.')}</p>
  </fieldset>;
}
